import React, { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Button, Grid, Container, Card } from "@mui/material";
import LabelTextField from "../../components/shared/LabelTextField";
import List from "../../components/shared/List";
import { useSettingsContext } from "../../components/settings";

import { color } from "../../utils/constant";

// SELECTORS
import {
  getPatientList,
  getPaginationInfo,
} from "../../data/selectors/Patient/patient.selector";
// TALONS
import usePatient from "../../data/talons/Patient/usePatient";

/**
 * Patient Master - Get Screen
 * Mirrors the Doctor screen structure, but with:
 * Columns: name, phone_no, email_id, age, gender
 * Filters: Name only
 */
export default function PatientList() {
  const [rowsPerPage, setRowsPerPage] = useState(15);
  const settings = useSettingsContext();

  // Hook for list (fetch + columns + filters)
  const { gridHeaders, loading, Name, handleNameChange, fetchPatientList } =
    usePatient();

  // Redux data
  const patientList = useSelector(getPatientList);
  const paginationInfo = useSelector(getPaginationInfo);

  // Initial fetch
  useEffect(() => {
    fetchPatientList({
      current_page: 1,
      row_count: rowsPerPage,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rowsPerPage]);

  const onSubmit = useCallback(
    async (e) => {
      e?.preventDefault();
      await fetchPatientList({
        current_page: 1,
        row_count: rowsPerPage,
      });
    },
    [fetchPatientList, rowsPerPage]
  );

  return (
    <Container
      maxWidth={settings.themeStretch ? false : "lg"}
      sx={{
        flexGrow: 1,
        display: "flex",
        flexDirection: "column",
        mt: 1,
      }}
    >
      {/* Filters Row */}
      <Grid container spacing={2}>
        <Grid item xs={12} sm={3} md={2}>
          <LabelTextField
            size="small"
            LabelTitle={"Name/Mobile no."}
            LabelValue={Name}
            handleLabelChange={handleNameChange}
            maxTextLength="50"
          />
        </Grid>

        <Grid
          container
          direction="row"
          item
          xs={6}
          sm={3}
          md={2}
          sx={{ alignItems: "center" }}
        >
          <Button
            variant="contained"
            onClick={onSubmit}
            sx={{
              maxHeight: 40,
              backgroundColor: color.button,
              borderRadius: 3,
              "&:hover": {
                backgroundColor: color.button,
              },
            }}
          >
            Get Data
          </Button>
        </Grid>
      </Grid>

      {/* List Card */}
      <Card
        sx={{
          flexGrow: { md: 1 },
          display: { md: "flex" },
          flexDirection: { md: "column" },
          my: "12px",
          borderRadius: "12px",
          boxShadow:
            "0 0 2px 0 rgba(145, 158, 171, 0.2),0 12px 24px -4px rgba(145, 158, 171, 0.12)",
        }}
      >
        <List
          loading={loading}
          data={patientList}
          paginationData={paginationInfo}
          columnsData={gridHeaders}
          getRowId={(row) => row.id}
          autoHeight={true}
          pageCount={Number(paginationInfo.total_page)}
          totalRecords={paginationInfo.total_count}
          onPageChange={async (page, rowsPerPageNew) => {
            setRowsPerPage(rowsPerPageNew);
            await fetchPatientList({
              current_page: page,
              row_count: rowsPerPageNew,
            });
          }}
        />
      </Card>
    </Container>
  );
}
